import React, { useEffect, useState } from "react"
import LessonHandler from "./LessonHandler"

function LessonList({ lessons, setLessons, userPrefs, setUserPrefs }) {
    const [sortBy, setSortBy] = useState('none')

    const visibleLessons = lessons.filter((lesson) =>
        lesson.year == userPrefs.visibleYear ||
        userPrefs.visibleYear == 'all' ||
        !userPrefs.visibleYear
    )

    const sortString = function (a, b) {
        const aUpper = a.toUpperCase()
        const bUpper = b.toUpperCase()
        if (aUpper < bUpper)
            return -1
        else if (aUpper > bUpper)
            return 1
        return 0
    }

    let sortedLessons = visibleLessons.sort((a, b) => {
        switch (sortBy) {
            case 'number':
                return parseInt(a.id) - parseInt(b.id)
            case 'materie':
                return sortString(a.subject, b.subject)
            case 'profesor':
                return sortString(a.professor, b.professor)
            case 'serie':
                return sortString(a.studentBatch, b.studentBatch)
            case 'data':
                return new Date(b.dateOfMeeting) - new Date(a.dateOfMeeting)
            case 'an':
                return parseInt(a.year) - parseInt(b.year)
            default:
                return -1;
        }
    })

    if (userPrefs.seeUpcomingOnly) {
        sortedLessons = sortedLessons.filter(
            (value) => new Date(`${value.dateOfMeeting} ${value.timeOfMeeting}`) >= new Date()
        )
    }

    const components = sortedLessons.map((lesson, index) => (
        <LessonHandler
            userPrefs={userPrefs}
            setUserPrefs={setUserPrefs}
            data={lesson}
            key={index}
            id={lesson.id}
            deleteHandler={() => {
                setLessons(lessons.filter((current) => current.id != lesson.id));
                setUserPrefs({ ...userPrefs, fetchRequested: true })
            }}
        />
    ))

    if (userPrefs.useOldList) {
        return (
            <div className="lesson-list">
                {components}
            </div>
        );
    } else {
        return <>
            <table className="lesson-table">
                <thead>
                    <th onClick={() => setSortBy(`data`)}>Data <i className="fas fa-solid fa-caret-down"></i></th>
                    <th onClick={() => setSortBy(`ora`)}>Ora <i className="fas fa-solid fa-caret-down"></i></th>
                    <th onClick={() => setSortBy(`an`)}>An <i className="fas fa-solid fa-caret-down"></i></th>
                    <th onClick={() => setSortBy(`materie`)}>Materia <i className="fas fa-solid fa-caret-down"></i></th>
                    <th onClick={() => setSortBy(`profesor`)}>Profesor <i className="fas fa-solid fa-caret-down"></i></th>
                    <th onClick={() => setSortBy(`serie`)}>Seria <i className="fas fa-solid fa-caret-down"></i></th>
                    <th>Modifică</th>
                </thead>
                <tbody>
                    {components}
                </tbody>
            </table>
        </>
    }
}

export default LessonList;
